import React from "react";
import { Box, FormLabel, Grid as GridBase, TextField } from "@mui/material";

import { formattedAmount, getFormatDate } from "@/helpers/utils";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

type OtherDetailsProps = {
  lc?: {
    extend_start_date?: string | Date | null;
    extend_end_date?: string | Date | null;
    extend_budget?: string | number | null;
  } | null;
};

const Grid = GridBase as React.ComponentType<Record<string, any>>;

function OtherDetails({ lc }: OtherDetailsProps) {
  return (
    <Box
      width="100%"
      sx={{
        border: "1px solid var(--neutral-200)",
        borderRadius: "var(--radius-container)",
        px: 2,
        pt: 1,
        pb: 2,
        mt: 2,
      }}
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, md: 8 }} sx={{ py: 0 }}>
          <FormLabel sx={{ fontWeight: 600 }}>Campaign Date</FormLabel>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                value={getFormatDate(lc?.extend_start_date)}
                disabled
                size="small"
                slotProps={{
                  input: {
                    endAdornment: <RpSvgIcon name="month_calender" size={30} />,
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                value={getFormatDate(lc?.extend_end_date)}
                disabled
                size="small"
                slotProps={{
                  input: {
                    endAdornment: <RpSvgIcon name="month_calender" size={30} />,
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 4,
          }}
          sx={{
            borderLeft: {
              md: "1px solid var(--neutral-200)",
              xs: "none",
            },
            px: {
              md: 2,
              xs: 0,
            },
            py: {
              md: 0,
              xs: 2,
            },
          }}
        >
          <FormLabel sx={{ fontWeight: 600 }}>Location Budget</FormLabel>
          <TextField
            fullWidth
            value={formattedAmount(lc?.extend_budget, "en-US", "USD")}
            disabled
            size="small"
            slotProps={{
              input: {
                startAdornment: <RpSvgIcon name="money" size={30} />,
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default OtherDetails;
